import { type ImgHTMLAttributes, type SyntheticEvent, useCallback, useEffect, useRef, useState } from 'react';

const ANIMATION_DELAY_MS = 100;

export const useImageLoadAnimation = (props: {
    isVisible: boolean;
    onLoad?: ImgHTMLAttributes<HTMLImageElement>['onLoad'];
    onError?: ImgHTMLAttributes<HTMLImageElement>['onLoad'];
}) => {
    const { isVisible, onLoad, onError } = props;
    const [isLoaded, setIsLoaded] = useState(false);
    const [isFailed, setIsFailed] = useState(false);
    const [needsAnimation, setNeedsAnimation] = useState(false);
    const loadStartTimeRef = useRef<number>(0);

    // Устанавливаем время начала загрузки
    useEffect(() => {
        if (isVisible) {
            loadStartTimeRef.current = performance.now();
        }
    }, [isVisible]);

    const handleLoad = useCallback(
        (e: SyntheticEvent<HTMLImageElement>) => {
            const loadEndTime = performance.now();
            const loadDuration = loadEndTime - loadStartTimeRef.current;

            if (loadDuration >= ANIMATION_DELAY_MS) {
                setNeedsAnimation(true);
            }

            setIsLoaded(true);
            onLoad?.(e);
        },
        [onLoad]
    );

    // Обработка ошибок загрузки
    const handleError = useCallback(
        (e: SyntheticEvent<HTMLImageElement>) => {
            onError?.(e);
            setIsFailed(true);
        },
        [onError]
    );

    return {
        isLoaded,
        isFailed,
        needsAnimation,
        onLoad: handleLoad,
        onError: handleError,
    };
};
